// src/components/About.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  FaHistory,
  FaGraduationCap,
  FaBuilding,
  FaGlobe,
  FaBook
} from 'react-icons/fa';
import './About.css';

const About = () => {
  const { t, i18n } = useTranslation();

  // Determine if the current language is Arabic
  const isArabic = i18n.language === 'ar';

  return (
    <div className={`about-page ${isArabic ? 'rtl' : 'ltr'}`}>
      <Container className="my-5">
      

        {/* Introduction Section */}
        <Row className="mb-5">
      
          <Col md={6}>
            <h2 className="section-title">
              <FaHistory className="icon" /> {t('aboutPage.introduction.heading')}
            </h2>
            <p className="section-text">{t('aboutPage.introduction.description')}</p>
          </Col>
        </Row>

        {/* Vision and Mission Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="section-title">
              <FaGraduationCap className="icon" /> {t('aboutPage.visionMission.heading')}
            </h2>
            <Row>
              <Col md={6} className="mb-4">
                <div className="vision-mission-box">
                  <p>{t('aboutPage.visionMission.vision')}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="vision-mission-box">
                 
                  <p>{t('aboutPage.visionMission.mission')}</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Achievements Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="section-title">
              <FaBuilding className="icon" /> {t('aboutPage.achievements.heading')}
            </h2>
            <ul className="list-unstyled">
              <li className="mb-3">
                <FaBook className="list-icon" />
                <strong>{t('aboutPage.achievements.diploma')}</strong>
              </li>
              <li className="mb-3">
                <FaBook className="list-icon" />
                <strong>{t('aboutPage.achievements.conferences')}</strong>
              </li>
              <li className="mb-3">
                <FaBook className="list-icon" />
                <strong>{t('aboutPage.achievements.publications')}</strong>
              </li>
            </ul>
          </Col>
        </Row>

        {/* Collaborations Section */}
        <Row className="mb-5">
          <Col>
            <h2 className="section-title">
              <FaGlobe className="icon" /> {t('aboutPage.collaborations.heading')}
            </h2>
            <ul className="list-unstyled">
              <li className="mb-3">
                <FaBook className="list-icon" />
                {t('aboutPage.collaborations.local')}
              </li>
              <li className="mb-3">
                <FaBook className="list-icon" />
                {t('aboutPage.collaborations.international')}
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
